import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "影视作品", to: "/category/films" },
  { label: "明星人物", to: "/category/stars" },
  { label: "网络话题", to: "/category/topics" },
  { label: "关于我们", to: "/about" },
];

const socials = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-qq-fill", label: "QQ" },
  { icon: "ri-youtube-fill", label: "视频号" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100/80">
      <div className="grid grid-cols-1 gap-8 px-4 py-10 md:grid-cols-4 md:px-8 md:py-14">
        <div className="flex flex-col gap-3 md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 font-heading text-lg font-bold text-background-50">
              巨
            </span>
            <span className="font-heading text-lg font-bold text-background-50">
              巨乳娱乐资讯网
            </span>
          </div>
          <p className="max-w-md text-sm leading-relaxed">
            聚合影视作品介绍、影视人物资料与网络热门话题的综合娱乐资讯平台，
            为影视爱好者提供权威、及时、有条理的资讯阅读体验。
          </p>
          <div className="flex gap-2 pt-1">
            {socials.map((item) => (
              <span
                key={item.label}
                aria-label={item.label}
                title={item.label}
                className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-900 text-background-100/70 transition-colors hover:bg-accent-500 hover:text-background-50 cursor-pointer"
              >
                <i className={item.icon} aria-hidden="true"></i>
              </span>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <p className="font-heading text-sm font-bold text-background-50">
            快速导航
          </p>
          <ul className="flex flex-col gap-2 text-sm">
            {quickLinks.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="transition-colors hover:text-accent-400"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex flex-col gap-3">
          <p className="font-heading text-sm font-bold text-background-50">
            联系与说明
          </p>
          <ul className="flex flex-col gap-2 text-sm">
            <li>
              <a
                href="mailto:contact@juentertainment.example"
                className="transition-colors hover:text-accent-400"
              >
                contact@juentertainment.example
              </a>
            </li>
            <li>内容合作与资讯纠正欢迎来信</li>
            <li>本站评论与搜索为前端演示功能</li>
          </ul>
        </div>
      </div>

      <div className="flex flex-col items-center justify-between gap-2 border-t border-primary-900 px-4 py-4 text-xs md:flex-row md:px-8">
        <span>© 2025 巨乳娱乐资讯网 · 保留所有权利</span>
        <span>本站内容为演示数据，仅用于产品展示</span>
      </div>
    </footer>
  );
}